import React, { useState } from "react";
import { Link } from "react-router-dom";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <a
            className="navbar-brand page-scroll"
            href="#page-top"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyontents: "center",
            }}
          >
            <img src="./img/ZL_Logo_2023.png" width={250} height={85} />
            <marquee direction="left" height={80} scrollAmount={2} style={{}}>
              <p
                style={{
                  color: "#000080",
                  marginTop: 30,
                }}
              >
                Connecting <span style={{ color: "orange" }}>Businesses</span>
              </p>
            </marquee>
          </a>
        </div>
        {/* <Dropdown
          nav
          onMouseOver={() => {
            setDropdownServices(true);
          }}
          onMouseLeave={() => {
            setDropdownServices(false);
          }}
          isOpen={dropdownServices}
        >
          <DropdownToggle
            caret
            color="default"
            href="#pablo"
            nav
            onClick={(e) => e.preventDefault()}
          >
            <i className="now-ui-icons design_app mr-1"></i>
            <p>SERVICES</p>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem to="/index" tag={Link}>
              <i className="now-ui-icons business_chart-pie-36 mr-1"></i>
              Software Development
            </DropdownItem>
            <DropdownItem
              href="https://demos.creative-tim.com/now-ui-kit-react/#/documentation/introduction?ref=nukr-index-navbar"
              target="_blank"
            >
              <i className="now-ui-icons design_bullet-list-67 mr-1"></i>
              Software Maintenance
            </DropdownItem>
            <DropdownItem
              href="https://demos.creative-tim.com/now-ui-kit-react/#/documentation/introduction?ref=nukr-index-navbar"
              target="_blank"
            >
              <i className="now-ui-icons design_bullet-list-67 mr-1"></i>
              IT Services
            </DropdownItem>
            <DropdownItem
              href="https://demos.creative-tim.com/now-ui-kit-react/#/documentation/introduction?ref=nukr-index-navbar"
              target="_blank"
            >
              <i className="now-ui-icons design_bullet-list-67 mr-1"></i>
              Management Consultancy
            </DropdownItem>
            <DropdownItem
              href="https://demos.creative-tim.com/now-ui-kit-react/#/documentation/introduction?ref=nukr-index-navbar"
              target="_blank"
            >
              <i className="now-ui-icons design_bullet-list-67 mr-1"></i>
              Disaster Recovery
            </DropdownItem>
            <DropdownItem
              href="https://demos.creative-tim.com/now-ui-kit-react/#/documentation/introduction?ref=nukr-index-navbar"
              target="_blank"
            >
              <i className="now-ui-icons design_bullet-list-67 mr-1"></i>
              Network Infra structure Conversion
            </DropdownItem>
          </DropdownMenu>
        </Dropdown> */}
        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          {/* <Dropdown
            isOpen={dropdownServices}
            onMouseOver={() => {
              setDropdownServices(true);
            }}
            onMouseLeave={() => {
              setDropdownServices(false);
            }}
          >
            <DropdownToggle caret>
              This dropdown's menu is right-aligned
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem header>Header</DropdownItem>
              <DropdownItem disabled>Action</DropdownItem>
              <DropdownItem>Another Action</DropdownItem>
              <DropdownItem divider />
              <DropdownItem>Another Action</DropdownItem>
            </DropdownMenu>
          </Dropdown> */}
          {/* <Dropdown
            onMouseOver={() => {
              setDropdownServices(true);
            }}
            onMouseLeave={() => {
              setDropdownServices(false);
            }}
            isOpen={dropdownServices}
          >
            <DropdownToggle caret>Dropdown</DropdownToggle>
            <DropdownMenu>
              <DropdownItem header>Header</DropdownItem>
              <a href="/">Hello</a>
              <br />
              <a>Hello</a>
              <br />
              <a>Hello</a>
              <br />
              <a>Hello</a>
              <br />
            </DropdownMenu>
          </Dropdown> */}

          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#features" className="page-scroll">
                Features
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                About
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Services
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Contact
              </a>
            </li>
            <li>
              {/* <Select
                defaultValue="lucy"
                style={{ width: 120 }}
                onChange={handleChange}
              >
                <Option value="jack">Jack</Option>
                <Option value="lucy">Lucy</Option>
                <Option value="disabled" disabled>
                  Disabled
                </Option>
                <Option value="Yiminghe">yiminghe</Option>
              </Select> */}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
